/**
 * Converts a Brazilian-formatted price string to a float number.
 * e.g. "1.234,56" → 1234.56
 */
export const formatStringToNumber = (formattedString) => {
    if (!formattedString || formattedString === '') return 0;

    return parseFloat(
        formattedString
            .replace(/\./g, '')  // remove thousands separator
            .replace(',', '.')   // replace decimal comma with dot
    );
};

/**
 * Parses a cart product into the GTM data layer shape.
 */
export const parseCartProduct = (product) => ({
    name:     product.name,
    id:       product.productId,
    price:    formatStringToNumber(product.price),
    category: product.typeMarkdown,
    quantity: product.qty || 1,
});

/**
 * Parses a refund product into the GTM data layer shape.
 */
export const parseRefundProduct = (product) => ({
    id:   product.productId,
    name: product.name,
    qty:  product.qty || 1,
});

/**
 * Returns true if the product data available for a checkout event is empty.
 */
export const isCheckoutProductDataEmpty = (data, fallback) => {
    if (!data && fallback.length === 0) return true;
    if (Array.isArray(data) && data.length === 0) return true;
    return false;
};
